import React, { useContext } from 'react';
import ApiContext from 'api/ApiContext';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

interface Props {
  electionId: string;
}

const CountedCircles = ({ electionId }: Props) => {
  const { t } = useTranslation('wap');
  const { language, getAggregatingDomains } = useContext(ApiContext);

  const query = useQuery(['aggregating_domains', electionId], () =>
    getAggregatingDomains(electionId),
  );

  const records = query.data?.data?.records;

  const countedCircles = records?.filter((record) => record.finished);
  const uncountedCircles = records?.filter((record) => !record.finished);

  return (
    <>
      {countedCircles?.length > 0 && (
        <div>
          <strong className="countedcircles__list-title">
            {t('countedcircles_counted')}
          </strong>
          <ul className="countedcircles__list">
            {countedCircles?.map((record) => (
              <li className="countedcircles__list-item" key={record.name[language]}>
                {record.name[language]}
              </li>
            ))}
          </ul>
        </div>
      )}
      {uncountedCircles?.length > 0 && (
        <div>
          <strong className="countedcircles__list-title">
            {t('countedcircles_not_counted')}
          </strong>
          <ul className="countedcircles__list">
            {uncountedCircles?.map((record) => (
              <li className="countedcircles__list-item" key={record.name[language]}>
                {record.name[language]}
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};

export default CountedCircles;
